export const SET_COIN_FILTER = '@account-search/set-coin-filter';
export const SET_SEARCH_STRING = '@account-search/set-search-string';
